import request from '@/utils/axios';

const {log} = console;
export const l = log;

// 排空
export function postFnc(updata, b1) {
    let newUpdata = {};
    let n = 0;
    for (let x in updata) {
        if (updata[x] !== '' && updata[x] !== undefined && updata[x] !== null) {
            newUpdata[x] = updata[x];
            n++;
        }
    }
    if (b1) {
        return {
            data: newUpdata,
            num: n
        };
    } else {
        return newUpdata;
    }

}
// 格式化时间
const fmtDate = (date, fmt) => {
    let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
            );
        }
    }
    return fmt;
};
// 时间戳转日期
export function TtoDay(time, fmt = 2) {
    // console.log(time)
    if (time.toString().length == 10) {
        time = parseInt(time) * 1000;
    }
    if (time > 0) {
        switch (fmt) {
            case 1:
                return fmtDate(new Date(time), 'yyyy-MM-dd');
            case 2:
                return fmtDate(new Date(time), 'yyyy-MM-dd hh:mm');
            case 3:
                return fmtDate(new Date(time), 'MM月dd日 hh:mm');
            case 4:
                return fmtDate(new Date(time), 'yyyy-MM-dd hh:mm:ss');
            case 5:
                return fmtDate(new Date(time), 'hh:mm');
            case 6:
                return fmtDate(new Date(time), 'hh:mm:ss');
            case 7:
                return fmtDate(new Date(time), 'yyyy年MM月dd日');
            case 8:
                return fmtDate(new Date(time), 'yyyy.MM.dd');
            case 9:
                return fmtDate(new Date(time), 'MM.dd');
            case 10:
                return fmtDate(new Date(time), 'yyyy/MM/dd');
            case 11:
                return fmtDate(new Date(time), 'MM-dd hh:mm:ss');
            default:
                return fmtDate(new Date(time), 'yyyy-MM-dd');
        }
    }
}

// 转换时间格式
export function changeT(T) {
    if (T == '') {
        return '';
    }
    function add0(m) {
        return m < 10 ? "0" + m : m;
    }
    function format(shijianchuo) {
        //console.log(shijianchuo);
        if (
            shijianchuo == "" ||
            shijianchuo == undefined ||
            shijianchuo == null
        ) {
            return "";
        }
        //shijianchuo是整数，否则要parseInt转换
        var time = new Date(shijianchuo);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        return y + "-" + add0(m) + "-" + add0(d);
    }
    return format(T);
}

// 转换时间格式
export function changeT2(T, n) {
    //console.log(T, n);
    if (T == null || T == undefined || T == '' || n == undefined) {
        return '';
    }
    if (T[n] == '') {
        return '';
    }
    function add0(m) {
        return m < 10 ? "0" + m : m;
    }
    function format(shijianchuo) {
        //console.log(shijianchuo);
        if (
            shijianchuo == "" ||
            shijianchuo == undefined ||
            shijianchuo == null
        ) {
            return "";
        }
        //shijianchuo += (24 * 60 * 60 * 1000)
        //shijianchuo是整数，否则要parseInt转换
        var time = new Date(shijianchuo);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        return y + "-" + add0(m) + "-" + add0(d);
    }
    return format(T[n]);
}

// 字符串转时间格式
export function strTtime(str, t = 1000) {
    if (str != undefined && str != null && str != '') {
        let n = new Date(str);
        let m = n.getTime() + 8 * 60 * 60 * t;
        let ret = new Date(m);
        // let ret = new Date(parseInt(m)).toLocaleString().replace(/:\d{1,2,3}$/, ' ');
        return ret;
    } else {
        return "";
    }
}

// 字符串转时间格式
export function strTtimelong(str, t = 1000) {
    if (str != undefined && str != null && str != '') {
        let n = new Date(str);
        let m = n.getTime() + 8 * 60 * 60 * t;
        // let ret = new Date(m);
        let ret = new Date(parseInt(m)).toLocaleString().replace(/:\d{1,2,3}$/, ' ');
        return ret;
    } else {
        return "";
    }
}

// 查询selectList列表
export function selectList(id) {
    return request({
        url: '/api/v1/dict-data/option-select?dictType=' + id,
        method: 'get',
    })
}

//返回所属值
export function backVal(val, arr, keyName, valName) {
    var backval = '';
    // console.log(val, arr, keyName, valName);
    arr.map(function (item) {
        var v0 = Number(item[keyName]);
        var v1 = Number(val);
        if (v0 == v1) {
            backval = item[valName];
        }
    })
    return backval;
}
//返回所属值
export function backVal1(val, arr, keyName, valName) {
    var backval = '';
    //console.log(val, arr, keyName, valName);
    arr.map(function (item) {
        if (item[keyName] == val) {
            backval = item[valName];
        }
    })
    return backval;
}

// 获取区队
export function backQd() {
    return request({
        url: '/api/v1/dxsf/dept?level=2',
        method: 'get',
        params: ''
    })
}

// 获取区队
export function backQd1() {
    return request({
        url: '/api/v1/deptTree',
        method: 'get',
    })
}

// 上传文件
export function upFileB64(datas, fnc) {
    return request({
        url: '/api/v1/dxsf/dev/official/upload/base64',
        method: 'post',
        data: datas,
        timeout: 120000,
        onUploadProgress: progressEvent => {
            if (fnc !== undefined) {
                fnc(progressEvent);
            }
        }
    })
}
// 上传文件
export function upFile(datas, fnc) {
    return request({
        url: '/api/v1/dxsf/official/upload',
        method: 'post',
        data: datas,
        timeout: 120000,
        onUploadProgress: progressEvent => {
            if (fnc !== undefined) {
                fnc(progressEvent);
            }
        }
    })
}


//匹配选择器
export function findsele(arr, str) {
    let ret = "";
    arr.map(function (item) {
        item.value == str && (function () {
            ret = item.label;
        })()
    })
}


//订单状态
export function tradeState(fun) {
    var arr = [];
    var objs = {};
    sel("dxsf_order_trade_state").then((response) => {
        if (response.code == 200) {
            arr = [];
            objs = {};
            response.data.map(function (item) {
                var obj = {
                    value: item.dictValue,
                    label: item.dictLabel,
                };
                arr.push(obj);
                objs[item.dictValue] = item.dictLabel;
            });
        } else {
            arr = [];
            objs = {};
        }
        fun([arr, objs])
    });

}

// 返回时间戳
export function getT(d) {
    let t = new Date(d);
    let n = t.getTime();
    return n;
}

// 判断是否有值
export function knval(v) {
    let r = false;
    if (v) {
        r = true;
    }
    return r;
}


// WEBPACK FOOTER //
// ./src/utils/tool.js